export * from '@egovsolutions/angular-egov-api/ppt/common';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { pptLookupResponseAdapter } from '@egovsolutions/angular-egov-api/ppt/internal';
import { map, tap } from 'rxjs/operators';
import * as i1 from '@egovsolutions/angular-egov-api/common';
import { createEgovAPINotFoundError } from '@egovsolutions/angular-egov-api/common';
import { adaptPPTBills } from '@egovsolutions/angular-egov-api/ppt/internal/basic-models';

class PPTLookupNetworkService {
    constructor(api) {
        this.api = api;
    }
    // Lookup suggestions
    getSuggestions$(query) {
        return this.api.request$({ endpoint: 'suggest/{{query}}', urlFields: { query } }).pipe(map(response => response.suggest), map(suggestions => {
            const suggestionTypes = Array.from(new Set(suggestions.map(s => s.type)));
            const fileteredSuggestions = [];
            let suggestionTypeIndex = 0;
            while (suggestions.length && fileteredSuggestions.length < 10) {
                const suggestionType = suggestionTypes[suggestionTypeIndex];
                const suggestionForType = suggestions.find(s => s.type === suggestionType);
                if (suggestionForType) {
                    suggestions.splice(suggestions.indexOf(suggestionForType), 1);
                    fileteredSuggestions.push(suggestionForType);
                }
                suggestionTypeIndex = (suggestionTypeIndex + 1) % suggestionTypes.length;
            }
            return fileteredSuggestions;
        }));
    }
    // Actual lookup
    parcelLookup$(query, sort, offset = 0, amount = 20) {
        const urlParameters = {
            start: offset,
            length: amount,
        };
        if (sort) {
            urlParameters.sort = sort.active;
            urlParameters.order = sort.direction.toUpperCase();
        }
        return this.api.request$({
            endpoint: 'parcels/{{query}}',
            urlFields: { query },
            urlParameters,
        })
            .pipe(map(pptLookupResponseAdapter));
    }
}
PPTLookupNetworkService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTLookupNetworkService, deps: [{ token: i1.EgovAPI }], target: i0.ɵɵFactoryTarget.Injectable });
PPTLookupNetworkService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTLookupNetworkService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTLookupNetworkService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.EgovAPI }]; } });

class PPTNetworkService {
    constructor(api) {
        this.api = api;
    }
    // State and info
    loadState$() {
        return this.api.request$({ endpoint: 'status/PPT' }).pipe(map(r => r.PPT), tap(r => r.disallowPaymentTypes = r.disallowPaymentMethods), 
        // TODO: Remove this once this info is coming with the endpoint
        map(r => ({ ...r, installmentMonths: [6, 9, 12, 3] })));
    }
    // Bills
    bills$(accountNumber, taxYear) {
        return this.api.request$({
            endpoint: `due/PPT/{{accountNumber}}${taxYear ? '/{{taxYear}}' : ''}`,
            urlFields: { accountNumber, taxYear },
        }).pipe(map(response => {
            if (response.due && response.due.PPT === null)
                throw createEgovAPINotFoundError();
            const billsResponse = adaptPPTBills(response, true);
            return {
                ...billsResponse,
                bills: billsResponse.bills.map(bill => ({ ...bill, satisfiesBillPage: true })),
                parcels: billsResponse.parcels.map(parcel => ({ ...parcel, satisfiesBillPage: true })),
            };
        }));
    }
}
PPTNetworkService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTNetworkService, deps: [{ token: i1.EgovAPI }], target: i0.ɵɵFactoryTarget.Injectable });
PPTNetworkService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTNetworkService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PPTNetworkService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.EgovAPI }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { PPTLookupNetworkService, PPTNetworkService };
